import { IApplicationState, TCardId } from '../../../../../../types/types';

export const getRecentlyWatchCardId = (
    state: IApplicationState
): TCardId => {
    return state.kanbanView.recentlyWatchCardId;
};
